module.exports = __webpack_public_path__ + "img/bsn_4.4a82893f.png";